import { CheckedIcon, UnCheckedIcon } from '../icon';

export const Checkbox01 = ({ checked = false, handleToggle }) => {
  return (
    <div onClick={handleToggle} style={{ cursor: 'pointer' }}>
      {checked ? <CheckedIcon /> : <UnCheckedIcon />}
    </div>
  );
};
